import AuthBloc from "../bloc/auth_bloc";
import GeneralBloc from "../bloc/general_bloc";
import LanguageBloc from "../bloc/language_bloc";
import SessionBloc from "../bloc/session_bloc";
import Config from "../Config";
import BaseResponseJson from "../data/web/base_response_json";
import CryptoJS from "crypto-js"
import forge from "node-forge";
import CryptoService from './crypto_service';

class BaseWebService {
  static baseUrl() {
    return process.env.REACT_APP_BASE_URL + this.getContextPathBySource();
  }

  static version() {
    return process.env.REACT_APP_RELEASE_VERSION;
  }

  static async fixedHeaders() {
    let token = await AuthBloc.currentAccessToken();

    let headers = {
      "X-DeviceOs": "Web",
      // Authorization: "Bearer " + token,
    };

    return headers;
  }

  static async renewTokenHeaders() {
    let headers = {
      "X-DeviceOs": "Web",
      Device: "-",
      DeviceId: "-",
      Version: "-",
      // Authorization: "Bearer " + token,
    };

    return headers;
  }

  static async logoutHeaders() {
    let token = await AuthBloc.currentAccessToken();
    const session = await AuthBloc.checkSession();

    if (session) {
      token = session.data.accessToken;      
    }
    let dataEncry=await this.getRequestId();
    let headers = {
      Authorization: "Bearer " + token,
      Source:"PAMB",
      RequestId:dataEncry[1],
      Uuid:dataEncry[0]    
    };

    return headers;
  }

  static getKey(secret, salt) {
    let key = CryptoJS.PBKDF2(secret, salt, { hasher: CryptoJS.algo.SHA512, keySize: 16, iterations: 10 });
    return (key.toString(CryptoJS.enc.Hex)); // Truncate the key to 32 bytes
  }

  static getRequestId() {
    let Uuid=SessionBloc.getRequestUUID();            
    let RequestId="";
    let currentTime = Date.now();
    let twoMinutesLater = currentTime + (30 * 1000);  
    let corrId="";     
    corrId=Uuid+"_"+twoMinutesLater;
    /* let salt = CryptoJS.lib.WordArray.random(process.env.REACT_APP_SALT_LENGTH/2).toString();
    let iv = CryptoJS.lib.WordArray.random(process.env.REACT_APP_IV_LENGTH/2).toString();  
    let encryptedkey = this.getKey(Uuid, salt);            
    let randomKey = CryptoJS.lib.WordArray.random(8).toString();

    
    let cipher = forge.cipher.createCipher(process.env.REACT_APP_ENCRYTION_METHOD, randomKey);
    cipher.start({
        iv: iv, 
        additionalData: process.env.REACT_APP_ADDITIONAL_DATA,
        tagLength: 128
    }); 
    cipher.update(forge.util.createBuffer(corrId));
    cipher.finish();
    let encrypted = cipher.output;
    let encodedB64 = forge.util.encode64(encrypted.data);
    let tag = cipher.mode.tag; 
    RequestId = forge.util.encode64(tag.data);
    RequestId = btoa(salt+ encryptedkey + randomKey + iv + RequestId + encodedB64);  */
    let encryptionPromise = Promise.resolve("");
    encryptionPromise = CryptoService.encrypt(corrId,process.env.REACT_APP_ENCRYTION_PASS);
    return encryptionPromise.then(encryptedData => {
      RequestId = encryptedData ? Uuid.toUpperCase() + encryptedData : "";
      return [Uuid,RequestId]
  });    
    
  } 

  static async standardHeaders() {
    let token = await AuthBloc.getAccessToken();        
    let headers = {};        
    headers = {
      Authorization: "Bearer " + token,            
    };

    return headers;
  }

  static async newHeaders(role) {
    let token = await AuthBloc.currentAccessToken();
    const session = await AuthBloc.checkSession();
    let ChannelId=null;
    let PartnerCode=null; 
    let productId=null;   
    if (session) {
      token = session.data.accessToken;
      ChannelId=AuthBloc.getSegment()?.code || session.data.meta.metadata.attributes?.subChannel;
      PartnerCode=session.data.meta.metadata.attributes?.bankCode;
    }
    
    
    if(sessionStorage.getItem("productId")){
      productId=sessionStorage.getItem("productId");
    }
    let headers = {};
    let dataEncry=await this.getRequestId();
    headers = {
      Authorization: "Bearer " + token,
      UserType:role,
      Product:productId,
      ChannelId:ChannelId,
      PartnerCode:PartnerCode,
      Source:"PAMB",
      RequestId:dataEncry[1],
      Uuid:dataEncry[0]          
    };
    return headers;
  }

  static async tmpHeaders(type) {   
    let token=""; 
    let dataUser = JSON.parse(sessionStorage.getItem("tmp_dataUser"));    
    if (dataUser) {
      token = dataUser.data.accessToken;    
    }
    
    let headers = {};
    let dataEncry=await this.getRequestId();
    headers = {
      Authorization: "Bearer " + token,   
      Source:"PAMB",
      RequestId:dataEncry[1],
      Uuid:dataEncry[0]  
    };
    if(type){
      headers.UserType=type
    }
    return headers;
  }


  static async authHeaders() {
    let token = await AuthBloc.currentAccessToken();
    const session = await AuthBloc.checkSession();
    let ChannelId=null;
    let PartnerCode=null; 
    let productId=null; 

    if (session) {
      token = session.accessToken;
      ChannelId=AuthBloc.getSegment()?.code || session.data.meta.metadata.attributes?.subChannel;
      PartnerCode=session.data.meta.metadata.attributes?.bankCode;
    }

    if(sessionStorage.getItem("productId")){
      productId=sessionStorage.getItem("productId");
    }

    let headers = {};
    let dataEncry=await this.getRequestId();
    headers = {
      Authorization: "Bearer " + token,
      Product:productId,
      ChannelId:ChannelId,
      PartnerCode:PartnerCode,
      Source:"PAMB",
      RequestId:dataEncry[1],
      Uuid:dataEncry[0]        
    };
    return headers;
  }

  static emptyHeader() {
    let lang = GeneralBloc.getSelectedLanguage();
    let newLang = lang === "eng" ? "EN" : "BN";
    return {
      /* 'ChannelId': "fwdbanca", */
      Language: newLang,
      Authorization: SessionBloc.generateStatelessAuth(),
      "Content-Type": "application/json",
      Version: BaseWebService.version(),
      Source:"PAMB",
      Accept: "*/*",
    };
  }

  static getContextPathBySource() {
    return "/v1";
  }

  static baseResponseFromWeb(resp) {
    let success = resp.success /* || resp.accessToken.length > 0 */;
    let message = resp.status ? resp.status.message : resp.message;
    let code = resp.status ? resp.status.code : resp.code;
    let errorCode = resp.errors;
    let data = resp.data;
    let page = resp.page;

    return new BaseResponseJson(success, message, code, data, page, errorCode);
  }

  static baseResponseAuthFromWeb(resp) {
    let success = resp.success /* || resp.accessToken.length > 0 */;
    let message = resp.status ? resp.status.message : resp.message;
    let code = resp.status ? resp.status.code : resp.code;
    let errorCode = resp.errors;
    let data = resp;
    let page = resp.page;

    return new BaseResponseJson(success, message, code, data, page, errorCode);
  }
}

export default BaseWebService;
